import { addDisplayName, addHandlers, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { addNavigate } from 'shared/src/utils/addNavigate'
import {
  isImageFeedContent,
  RoundupGroup,
  videoThumbnail,
} from 'shared/src/api/types'

import { makeMediaUrl } from '../../utils/routes'
import { Lasso } from '../feed/fluid/rodeo/Lasso'
import { Button } from '../Button'

const useStyles = createUseStyles({
  container: {
    position: 'relative',
  },
  absoluteCenter: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  imageContainer: {
    position: 'relative',
    maxWidth: '100%',
    maxHeight: '100%',
    display: 'flex',
    justifyContent: 'center',
    pointerEvents: 'auto',
    paddingBottom: '0%',
    marginLeft: '10%',
    opacity: '60%',
  },
  image: {
    width: '60%',
    height: '100%',
    objectFit: 'contain',
  },
})

interface Props {
  group: RoundupGroup
  className?: string
}

export const Media: FC<Props> = flowMax(
  addDisplayName('Media'),
  addNavigate,
  addHandlers({
    navigateToMedia:
      ({ group: { media }, navigate }) =>
      () => {
        if (!media) {
          return
        }

        navigate(
          makeMediaUrl({
            mediaId: media.id,
          }),
          {
            state: {
              showBackButton: true,
            },
          }
        )
      },
  }),
  addProps(({ group: { media } }) => ({
    origin: media
      ? {
          user: media.user,
          mediaId: media.id,
        }
      : null,
  })),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({
    group: { media, products },
    origin,
    navigateToMedia,
    className,
    classes,
  }) => (
    <div className={classes.container}>
      {media && (
        <div className={classes.absoluteCenter}>
          <div className={classes.imageContainer}>
            <Button onClick={navigateToMedia}>
              <img
                src={
                  isImageFeedContent(media.content)
                    ? media.content.value.full
                    : videoThumbnail(media.content)
                }
                alt=""
                className={classes.image}
              />
            </Button>
          </div>
        </div>
      )}
      <Lasso
        origin={origin}
        products={products}
        layout="roundup"
        className={className}
      />
    </div>
  )
)
